var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetroType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "208.8%",
    height: "208.8%",
    x: "-54.4%",
    y: "-50.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.439360119 0 0 0 0 0.439360119 0 0 0 0 0.439360119 0 0 0 0.14 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__b",
    cx: 57,
    cy: 57,
    r: 57
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(40 36)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B6C2D4",
    d: "M52.852 37.813c1.186 0 2.148-.962 2.148-2.149V12.891c0-4.739-3.855-8.594-8.594-8.594h-2.793V2.148C43.613.962 42.651 0 41.465 0c-1.187 0-2.149.962-2.149 2.148v2.149h-9.775V2.148C29.541.962 28.579 0 27.393 0c-1.187 0-2.149.962-2.149 2.148v2.149h-9.668V2.148C15.576.962 14.614 0 13.428 0c-1.187 0-2.149.962-2.149 2.148v2.149H8.594C3.855 4.297 0 8.152 0 12.89v33.515C0 51.145 3.855 55 8.594 55h37.812C51.145 55 55 51.145 55 46.406c0-1.186-.962-2.148-2.148-2.148-1.187 0-2.149.962-2.149 2.148 0 2.37-1.927 4.297-4.297 4.297H8.594c-2.37 0-4.297-1.927-4.297-4.297V12.891c0-2.37 1.927-4.297 4.297-4.297h2.685v2.148c0 1.187.962 2.149 2.149 2.149 1.186 0 2.148-.962 2.148-2.149V8.594h9.668v2.148c0 1.187.962 2.149 2.149 2.149 1.186 0 2.148-.962 2.148-2.149V8.594h9.775v2.148c0 1.187.962 2.149 2.149 2.149 1.186 0 2.148-.962 2.148-2.149V8.594h2.793c2.37 0 4.297 1.927 4.297 4.297v22.773c0 1.187.962 2.148 2.149 2.148z",
    transform: "translate(30 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78F2",
    d: "M39.188 21.06c-.736-.362-1.614-.272-2.262.23l-4.297 3.33c-.938.727-1.109 2.077-.382 3.014.727.938 2.077 1.11 3.014.383l.833-.645v13.233c0 1.187.962 2.149 2.148 2.149 1.187 0 2.149-.962 2.149-2.149V22.988c0-.82-.467-1.568-1.203-1.929zM27.285 27.75c0-3.81-3.11-6.91-6.932-6.91-.019 0-.037.002-.056.003-.019 0-.037-.003-.056-.003-2.507 0-4.734 1.185-5.957 3.17-.622 1.01-.308 2.333.702 2.956.352.216.741.32 1.125.32.721 0 1.426-.363 1.832-1.022.428-.695 1.308-1.127 2.297-1.127.02 0 .038-.003.057-.003.019 0 .037.003.056.003 1.429 0 2.635 1.196 2.635 2.613 0 .81-1.08 1.666-1.76 2.06-.96.214-1.677 1.07-1.677 2.094 0 1.036.733 1.9 1.708 2.103l-.02.005c.017.007 1.75.75 1.75 1.809 0 1.44-1.173 2.613-2.614 2.613-.09 0-.179.007-.266.018-.839-.05-1.696-.574-2.166-1.337-.622-1.01-1.946-1.324-2.956-.702-1.01.623-1.325 1.946-.702 2.956 1.286 2.088 3.568 3.385 5.955 3.385.114 0 .224-.011.332-.028 3.72-.105 6.713-3.161 6.713-6.905 0-1.681-.764-3.012-1.731-3.994.928-.988 1.731-2.342 1.731-4.077z",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroType);
export default __webpack_public_path__ + "static/media/retro_type.530a61b3.svg";
export { ForwardRef as ReactComponent };